import React from 'react';

import './BlueBackgroundSVG.scss';

export default class BlueBackgroundSVG extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {};

    static defaultProps = {};

    render() {
        return (
            <div className="component-Layout-TitleWithUnderlineSubnav-BlueBackgroundSVG">
                <div className="mobile">
                    <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 540 63"
                        preserveAspectRatio="none"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                        <g
                            id="Page-1"
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                        >
                            <g
                                id="blue-ground-320"
                                fill="#F3F5F8"
                                fillRule="nonzero"
                            >
                                <path
                                    d="M0.0508016497,0 C3.60235714,0.0237438793 7.22470343,0.0594463621 10.9178406,0.107107448 C105.345652,1.32572281 157.194144,16.5329366 280.157428,15.426339 C354.149574,14.7604534 454.381747,11.323489 539.999873,8.80974367 C540.002558,22.6336809 539.962748,40.5998515 539.880444,62.7082546 L0.588236009,63 C0.0808333082,43.7167048 -0.0983114773,22.7167048 0.0508016497,0 Z"
                                    id="Path"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="desktop">
                    <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 540 59"
                        preserveAspectRatio="none"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                        <g
                            id="Page-1"
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                        >
                            <g
                                id="blue-ground-540"
                                fill="#F3F5F8"
                                fillRule="nonzero"
                            >
                                <path
                                    d="M0,8.11347 C12.9315406,1.988414 38.0558501,-0.668676 75.3729287,0.142198 C131.348546,1.35851 162.083679,16.53698 234.974766,15.432474 C307.865853,14.327968 422.296876,5.436899 471.832102,6.174544 C504.855586,6.666307 527.578219,8.822672 540,12.643638 L539.967882,59 L0.133838693,59 L0,8.11347 Z"
                                    id="Path"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        );
    }
}
